// components/CancelModal.js
import React from "react";
import { Modal, Box, Typography, Button, TextField } from "@mui/material";

const CancelModal = ({
  cancelModalOpen,
  handleCloseCancelModal,
  remarks,
  setRemarks,
  CancelTicket,
  ticketId,
  globalState,
}) => {
  return (
    <Modal
      open={cancelModalOpen}
      onClose={handleCloseCancelModal}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          p: 2,
          width: 500,
          height: 300,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          Why Cancelling?
        </Typography>
        <Typography sx={{ textAlign: "center", mb: 2 }}>
          Enter Remarks
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          sx={{ mb: 2 }}
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Button
            onClick={() =>
              CancelTicket(
                ticketId,
                globalState?.adminDetails?.user_name,
                remarks
              )
            }
            variant="contained"
            color="primary"
            sx={{ mb: 1, marginTop: "20px" }}
          >
            Yes, Cancel
          </Button>
          <Button
            onClick={handleCloseCancelModal}
            variant="outlined"
            color="secondary"
            sx={{ mb: 1, marginTop: "20px" }}
          >
            No, Go Back
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CancelModal;
